import Api from "../../../config/api";
import {
  CREATE_LEAD_QUOTATION,
  SEARCH_LEAD_QUOTATION,
  SEARCH_LEAD_QUOTATION_BY_ID,
  UPDATE_LEAD_QUOTATION,
} from "../../../utils/constants";
import { showToast } from "../../toast/ShowToast";

export const getQuotation = async (params: any) => {
  try {
    const res = await Api(false).get(SEARCH_LEAD_QUOTATION, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getQuotationById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_LEAD_QUOTATION_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createQuotation = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(true).post(CREATE_LEAD_QUOTATION, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateQuotation = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(true).put(`${UPDATE_LEAD_QUOTATION}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
